import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { DateSelectorComponent } from '@ildes/basic/date-selector/date-selector.component';
import { DropdownSelectorComponent } from '@ildes/basic/dropdown-selector/dropdown-selector.component';
import { PredictiveSearcherComponent } from '@ildes/basic/predictive-searcher/predictive-searcher.component';
import { SimpleHeaderComponent } from '@ildes/basic/simple-header/simple-header.component';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { InputPlaceComponent } from '@ildes/basic/input-place/input-place.component';
import { SelectUsersDialogComponent } from '@ildes/basic/select-users-dialog/select-users-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SessionStore } from '@ildes/stores/session.store';
import { CreateMaintenanceDialogComponent } from '@ildes/views/create-maintenance-dialog/create-maintenance-dialog.component';
import { ListMaintenanceItemComponent } from '@ildes/basic/list-maintenance-item/list-maintenance-item.component';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from '@ildes/services/toast.service';
import { first } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AlertDialogComponent } from '@ildes/basic/alert-dialog/alert-dialog.component';

const MAX_FILE_SIZE = 3 * 1000 * 1000;

const OPERATIVE_SECTION = {
    id: 'OPERATIVE',
    description: 'Operativa',
   // timeToResponse: 8
};
const SECTOR_TYPES = [
    {
        id: 'URBAN',
        description: 'Urbano',
    },
    {
        id: 'RURAL',
        description: 'Rural',
    },
];
const RESPONSE_OPERATION_ID = 'OPERATION';
const RESPONSE_OTHER_ID = 'OTHERS';
const RESPONSE_TYPES = [
  {
      id: RESPONSE_OPERATION_ID,
      description: 'Minuta de Operación',
  },
  {
      id: 'EXPANSION',
      description: 'Minuta de Expansión',
  },
  {
    id: 'THIRD',
    description: 'Minuta de Remisión a Terceros',
  },
  {
      id: 'IAP',
      description: 'Minuta de IAP',
  },
  {
      id: RESPONSE_OTHER_ID,
      description: 'Otros',
  }
];

const ORIGIN_WRITED = {
    id: 'WRITED',
    description: 'Escrito',
};
const ORIGIN_PQR_TYPES = [
    {
        id: 'PHONE',
        description: 'Telefónico',
    },
    {
        id: 'FACE_TO_FACE',
        description: 'Verbal',
    },
    ORIGIN_WRITED
];

const REQUEST_MAINTENANCE_ID = 'MAINTENANCE';
const REQUEST_OTHER_ID = 'OTHERS';
const EXPANSION_ID = 'EXPANSION';
const REQUEST_TYPES = [
    {
        id: REQUEST_MAINTENANCE_ID,
        description: 'Mantenimiento',
    },
    {
        id: EXPANSION_ID,
        description: 'Expansión',
    },
    {
        id: 'TAX',
        description: 'Impuesto alumbrado público',
    },
    {
        id: REQUEST_OTHER_ID,
        description: 'Otros',
    }
];
@Component({
    selector: 'app-create-pqr',
    standalone: true,
    imports: [
        ListMaintenanceItemComponent,
        ReactiveFormsModule,
        CommonModule,
        PredictiveSearcherComponent,
        SimpleHeaderComponent,
        MatStepperModule,
        MatFormFieldModule,
        MatInputModule,
        DropdownSelectorComponent,
        MatButtonModule,
        DateSelectorComponent,
        MatCheckboxModule,
        InputPlaceComponent,
        MatProgressBarModule,
        MatIconModule,
        AlertDialogComponent
    ],
    template: `
    <div class="container">
        <div class="scrollable-content">
            <simple-header title="Crear PQR" [back]="true" icon="close"></simple-header>
            <mat-vertical-stepper [linear]="true" #stepper>
                <mat-step label="Datos de la petición" [completed]="validateStep1">
                    <predictive-searcher
                        class="margin-top-8"
                        [mandatorySelection]="true"
                        [formControl]="selectedProjectForm"
                        label="Proyecto"
                        [service]="searchProjectAdapter"></predictive-searcher>
                    <mat-form-field appearance="outline" class="full-width" (click)="openSelectUserDialog()">
                        <mat-label>Funcionario que recibe la solicitud</mat-label>
                        <input matInput readonly [formControl]="receptor" maxlength="90">
                        <mat-error>
                            El nombre es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <dropdown-selector (selectedChange)="onRequestTypeChange($event)" class="column"  label="Tipo de solicitud" [types]="requestTypes" [(selected)]="requestType"></dropdown-selector>
                    <!-- <dropdown-selector class="column"  label="Área encargada" [types]="accountableSectionTypes" [(selected)]="accountableSection"></dropdown-selector> -->
                    <div class="section margin-top-8">
                        <h3>Fecha de radicado</h3>
                        <div>
                            <date-selector [date]="registrationDate" [minYear]=2000 [maxYear]=2080 (onChangeDate)="setRegistrationDate($event)" ></date-selector>
                        </div>
                    </div>
                    <dropdown-selector [disabled]="isMaintenance" class="column"  label="Tipo de respuesta" [types]="responseTypes" [(selected)]="responseType"></dropdown-selector>
                    <mat-form-field appearance="outline" class="full-width" *ngIf="isOtherResponseType">
                        <mat-label>Descripción del tipo de solicitud</mat-label>
                        <textarea rows="2" matInput [formControl]="responseTypeDescription"></textarea>
                    </mat-form-field>
                    <button [disabled]="!validateStep1" matStepperNext mat-button color="primary">Siguiente</button>
                </mat-step>
                <mat-step label="Datos de PQRS" [completed]="validateStep2">
                    <h3>Datos de peticionario</h3>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Nombre</mat-label>
                        <input matInput [formControl]="petitionerName" maxlength="20">
                        <mat-error>
                            El nombre es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Cédula</mat-label>
                        <input matInput [formControl]="identification" maxlength="20">
                        <mat-error>
                            La cédula es obligatoria
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Dirección del peticionario</mat-label>
                        <textarea rows="2" matInput [formControl]="petitionerAddress"></textarea>
                    </mat-form-field>
                    <h3>Introduzca un medio de contacto</h3>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Teléfono fijo</mat-label>
                        <input matInput [formControl]="phone" maxlength="20">
                        <mat-error>
                            El nombre es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Celular</mat-label>
                        <input matInput [formControl]="mobilePhone" maxlength="20">
                        <mat-error>
                            El nombre es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Otro medio de contacto</mat-label>
                        <input matInput [formControl]="otherContact" maxlength="20">
                        <mat-error>
                            El nombre es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Email</mat-label>
                        <input placeholder="Email (opcional)" matInput type="email" [formControl]="email" maxlength="200">
                        <mat-error>
                            Debe ser formato email
                        </mat-error>
                    </mat-form-field>
                    <app-alert-dialog
                        class="margin-bottom-8"
                        status="info"
                        *ngIf="!validContact"
                        text="Debe indicar un medio de contacto"
                        ></app-alert-dialog>
                    <dropdown-selector class="column"  label="Medio en que presenta la solicitud" [types]="originPqrTypes" [(selected)]="originPqr"></dropdown-selector>
                    <app-alert-dialog
                        class="margin-bottom-8"
                        status="info"
                        *ngIf="!originPqr"
                        text="Indique el medio por el que presentó la solicitud"
                        ></app-alert-dialog>
                    <h3>Anexos</h3>
                    <div>
                        <mat-checkbox
                            class="margin-bottom-16"
                            matRipple
                            role="button"
                            [checked]="hasAttachments"
                            (change)="onChange($event)">
                            Presenta anexos
                        </mat-checkbox>
                    </div>
                    <section *ngIf="this.hasAttachments">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Tipo de anexo</mat-label>
                            <input  matInput [formControl]="attachmentType" maxlength="20">
                            <mat-error>
                                El nombre es obligatorio
                            </mat-error>
                        </mat-form-field>
                        <div *ngFor="let file of files" >
                            <div class="attachment-list">
                                <div class="margin-8 attachment-column-1">
                                    <mat-icon class="margin-right-8">description</mat-icon>
                                    <span>{{file.name}}</span>
                                </div>
                                <div>
                                    <button mat-flat-button (click)="removeAttachment(file)">
                                        <mat-icon class="margin-right-8">close</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <mat-divider></mat-divider>
                        </div>
                        <button (click)="fileInput.click()" mat-flat-button *ngIf="!files?.length">
                            <mat-icon>attachment</mat-icon> Adjuntar archivos
                        </button>
                        <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file" multiple>
                    </section>
                    <button [disabled]="!validateStep2" matStepperNext mat-button color="primary">Siguiente</button>
                </mat-step>
                <mat-step label="Información de la actividad">
                    <mat-form-field appearance="outline" class="full-width padding-top-8">
                        <mat-label>Observaciones</mat-label>
                        <textarea rows="2" matInput [formControl]="pqrsDescription"></textarea>
                    </mat-form-field>
                    <section *ngIf="isExpansion || isMaintenance">
                      <h3>Ubicación y punto de referencia</h3>
                      <dropdown-selector class="column"  label="Sector" [types]="sectorTypes" [(selected)]="sector"></dropdown-selector>
                      <input-place
                          [required]="true"
                          class="column"
                          label="Dirección"
                          placeholder="CLL 33 45"
                          dark
                          [formControl]="address"
                          appearance="fill"></input-place>
                      <predictive-searcher
                          label="Barrio"
                          [formControl]="neighborhoodForm"
                          [service]="searchNeighborhoodAdapter"
                          class="column margin-right-8"></predictive-searcher>
                      <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Punto de referencia de ubicación</mat-label>
                          <input matInput maxlength="80" [formControl]="referencePointDescription">
                      </mat-form-field>
                    </section>
                    <button matStepperNext *ngIf="isMaintenance" [disabled]="!validateStep3" mat-button color="primary">Siguiente</button>
                    <div class="align-center padding-top-32" *ngIf="!isMaintenance">
                        <div class="padding-bottom-8">
                          <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
                        </div>
                        <div class="padding-bottom-8">
                            <button  (click)="this.create()" [disabled]="loading || !validateStep3" mat-raised-button color="primary" class="button-size-200">Guardar</button>
                        </div>
                    </div>
                </mat-step>
                <mat-step *ngIf="isMaintenance" label="Mantenimiento de la actividad">
                  <p *ngIf="!this.maintenance">
                      Para PQRS asignados al área de operación se necesita crear un mantenimiento.
                  </p>
                  <list-maintenance-item
                    orderno="Mantenimiento asociado a PQR"
                    *ngIf="maintenance"
                    [project]="selectedProjectForm.value?.typed || 'Sin proyecto'"
                    [state]="maintenance.state"
                    [type]="maintenance.type"
                    [address]="address?.value.typed"
                    [neighborhood]="neighborhoodForm?.value?.typed"
                    [referencePoint]="referencePointDescription?.value"
                    [painType]="maintenance.painType"
                    [painDescription]="pqrsDescription?.value"
                    [estimatedResolutionDate]="maintenance.estimatedResolutionDate"
                  ></list-maintenance-item>
                  <button (click)="this.createMaintenance()" mat-button>
                    <span *ngIf="this.maintenance">Borrar y crear otro</span>
                    <span *ngIf="!this.maintenance">Crear mantenimiento</span>
                  </button>
                  <div class="align-center padding-top-32" >
                      <div class="padding-bottom-8">
                        <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
                      </div>
                      <div class="padding-bottom-8">
                        <button (click)="this.create()" [disabled]="loading || !maintenance" mat-raised-button color="primary" class="button-size-200">Guardar</button>
                      </div>
                  </div>
                </mat-step>
            </mat-vertical-stepper>
        </div>
    </div>
    `,
    styleUrls: ['./create-pqr.component.css']
})
export class CreatePqrComponent implements OnInit {
    userPqrsId;
    files;
    @ViewChild('stepper') virtualStepper: any;
    selectedReceptor;
    pqrsDescription = new FormControl();
    referencePointDescription = new FormControl();
    searchProjectAdapter;
    selectedProjectForm = new FormControl();
    petitionerName = new FormControl('', [Validators.required]);
    petitionerAddress = new FormControl('', [Validators.required]);
    phone = new FormControl();
    mobilePhone = new FormControl();
    email = new FormControl('', [Validators.email]);
    identification = new FormControl('', [Validators.required]);
    otherContact = new FormControl();
    responseTypeDescription = new FormControl();
    originPqrTypes=ORIGIN_PQR_TYPES;
    originPqr;
    requestTypes=REQUEST_TYPES;
    requestType;
    receptor = new FormControl();
    registrationDate = new Date();
    //accountableSection;
    //accountableSectionTypes = ACCOUNTABLE_SECTION_TYPES;
    responseTypes = RESPONSE_TYPES;
    responseType;
    hasAttachments;
    attachmentType = new FormControl();
    sectorTypes = SECTOR_TYPES;
    sector;
    searchNeighborhoodAdapter;
    address = new FormControl();
    neighborhoodForm = new FormControl();
    loading = false;
    maintenance;
    constructor(
        private route: ActivatedRoute,
        private toast: ToastService,
        private dialog: MatDialog,
        private apiManager: ApiManagerService,
        private location: Location,
    ) {
        this.searchProjectAdapter = (data) => {
            return this.apiManager.listProjects(data);
        };

        this.searchNeighborhoodAdapter = (neighborhood) => {
            return this.apiManager.getFromCatalog('neighborhood', neighborhood)
        };
    }
    resetForm() {
      this.selectedReceptor = SessionStore.getInstance().get().user;
      this.receptor = new FormControl(`${this.selectedReceptor.name} ${this.selectedReceptor.surname}`);
      this.pqrsDescription.reset();
      this.referencePointDescription.reset();
      this.selectedProjectForm.reset();
      this.petitionerName.reset();
      this.petitionerAddress.reset();
      this.phone.reset();
      this.mobilePhone.reset();
      this.email.reset();
      this.identification.reset();
      this.otherContact.reset();
      this.responseTypeDescription.reset();
      this.originPqr =undefined;
      this.requestType = undefined;;
      this.receptor.reset();
      this.registrationDate = new Date();
      this.responseType = undefined;;
      this.hasAttachments = undefined;;
      this.attachmentType.reset();
      this.sector = undefined;
      this.address.reset();
      this.neighborhoodForm.reset();
      this.loading = false;
      this.maintenance = undefined;
      this.virtualStepper.reset()
    }
    ngOnInit(): void {
      this.route.queryParams.pipe(first()).subscribe((params) => {
        if (params.projectId) {   
            this.selectedProjectForm.setValue({
                typed: params.projectName,
                selected: { id: params.projectId, name: params.projectName }
            });
        }
        if (params.id) {
            this.userPqrsId = params.id;
            this.originPqr = ORIGIN_WRITED;
        }
        if (params.name) {
            this.petitionerName.setValue(`${params.name} ${params.surname}`);
        }
        if (params.address) {
            this.petitionerAddress.setValue(params.address);
            this.address.setValue({
                place: { lat: '', lng: '' },
                typed: params.address || '',
                lat: '',
                lng: ''
            });
        }
        
        if (params.email) {
            this.email.setValue(params.email);
        }
        if (params.description) {
            this.pqrsDescription.setValue(params.description);
        }
      });
      this.selectedReceptor = SessionStore.getInstance().get().user;
      this.receptor = new FormControl(`${this.selectedReceptor.name} ${this.selectedReceptor.surname}`);
    }

    get validateStep1() {
        //return true;

        return this.selectedProjectForm.value?.typed &&
            this.requestType &&
            this.responseType &&
            this.registrationDate &&
            (this.isOtherResponseType ? !!this.responseTypeDescription?.value?.trim() : true);
    }

    get validContact() {
        return (this.phone.value || this.mobilePhone.value || this.otherContact.value || (this.email.value && this.email.valid))
    }
    get validateStep2() {
        return this.petitionerName.value &&
            this.identification.value &&
            this.originPqr &&
            (this.phone.value || this.mobilePhone.value || this.otherContact.value) &&
            (this.hasAttachments ? (this.attachmentType.value && this.files?.length > 0) : true);
    }

    get validateStep3() {
      return this.pqrsDescription.value && ((this.isMaintenance || this.isExpansion) ? this.validAddressSection : true);
    }

    get validAddressSection() {
      return ( this.address.value?.typed || (this.address.value?.lat && this.address.value?.lng) || this.neighborhoodForm.value?.typed || this.referencePointDescription.value);
    }

    private performData() {
        const jsonAddress = this.address.value;
        let address = jsonAddress?.typed;
        let latitude = jsonAddress?.place?.lat;
        let longitude = jsonAddress?.place?.lng;
        let maintenance;
        let neighborhood = this.neighborhoodForm.value?.typed;
        let geolocation = {
          type: 'Point',
          coordinates: [longitude, latitude]
        };
        if (this.isMaintenance) {
          maintenance = {
            ...this.maintenance,
            ...{
              locationReferenceDescription: this.referencePointDescription?.value || '',
              project: this.selectedProjectForm.value.selected.id,
              address,
              ...longitude && latitude && { geolocation },
              neighborhood
            }
          }
        }
        
        return {
            ...this.isMaintenance && { maintenance },
            petitioner: {
                name: this.petitionerName.value,
                phone: this.phone.value,
                email: this.email.value,
                mobilePhone: this.mobilePhone.value,
                identification: this.identification.value,
                otherContact: this.otherContact.value,
                address: this.petitionerAddress.value
            },
            ...this.isOtherResponseType && { responseTypeDescription: this.responseTypeDescription.value },
            project: this.selectedProjectForm.value.selected.id,
            originPqr: this.originPqr?.id,
            requestType: this.requestType?.id,
            receptor: { id: this.selectedReceptor.id },
            pqrsDescription: this.pqrsDescription.value,
            referencePointDescription: this.referencePointDescription.value,
            //responseDays: this.accountableSection?.timeToResponse,
            registrationDate: this.registrationDate.toISOString(),
            //accountableSection: this.accountableSection?.id,
            responseType: this.responseType?.id,
            hasAttachments: this.hasAttachments,
            attachmentType: this.attachmentType.value,
            sector: this.sector?.id,
            address,
            ... longitude && latitude && { geolocation },
            neighborhood,
            ...this.userPqrsId && { userPqrsId: this.userPqrsId }
        }
    }

    onRequestTypeChange(data) {
      if (data?.id === REQUEST_MAINTENANCE_ID) {
        this.responseType = this.responseTypes.find(({id}) => id === RESPONSE_OPERATION_ID)
      } else if (this.isMaintenance) { // es de la iteración anterior, reseteamos para no dejar minuta de operación
        this.responseType = null;
      }
    }
    create() {
        const rawData = this.performData();
        const data = new FormData();

        const keys = Object.keys(rawData);

        keys.forEach((key) => {
            data.append(key, typeof rawData[key] === typeof {} ? JSON.stringify(rawData[key]): rawData[key]);
        });

        for (let i = 0; i < this.files?.length; i++) {
            data.append(`files[${i}]`, this.files[i], this.files[i].name);
        }

        this.loading = true;
        this.apiManager.createPQR(data).subscribe(() => {
          if (this.userPqrsId) {
            this.location.back()
            return;
          }
          this.loading = false;
          this.resetForm();
        }, () => {
          this.loading = false;
        })
    }

    setRegistrationDate(registrationDate) {
        this.registrationDate = registrationDate?.selectedDate;
    }

    onChange(event) {
        this.hasAttachments = event.checked;
        this.files = [];
    }

    // get isOperativeSectionAccountable() {
    //     return this.accountableSection === OPERATIVE_SECTION;
    // }

    get isOtherResponseType() {
      return this.responseType?.id === RESPONSE_OTHER_ID;
    }
    get isMaintenance() {
      return this.requestType?.id === REQUEST_MAINTENANCE_ID;
    }

    get isExpansion() {
      return this.requestType?.id === EXPANSION_ID;
    }

    openSelectUserDialog() {
        const dialog = this.dialog.open(SelectUsersDialogComponent, {
            width: '600px',
            height: '600px',
            panelClass: 'responsive-dialog',
            data: { selected: [{...this.selectedReceptor}], selection: SelectUsersDialogComponent.UNIQUE_SELECTION}
          });

        dialog.afterClosed().subscribe((data) => {
            if (data.close) {
                return;
            }
            this.selectedReceptor = data.selectedUser;
            this.receptor = new FormControl(`${this.selectedReceptor.name} ${this.selectedReceptor.surname}`);
        });
    }

    createMaintenance() {
      const dialog = this.dialog.open(CreateMaintenanceDialogComponent, {
        width: '600px',
        height: '600px',
        panelClass: 'responsive-dialog',
        data: {
          project: this.selectedProjectForm?.value?.selected || { name: this.selectedProjectForm?.value?.typed},
          painDescription: this.pqrsDescription.value
        }
      });

      dialog.afterClosed().subscribe((data) => {
        if (data.close) {
          return;
        }
        this.maintenance = data.maintenance;
      });
    }

    onFileSelected(event) {
        const { files } = event.target;
    
        if (!files?.length) {
          return;
        }

        for (let i = 0; i < files.length; i++) {
            if (files[i].size > MAX_FILE_SIZE) {
                this.toast.show('El tamaño de los ficheros no puede ser superior a 3 MB', 'error');
    
                return;
            }
        }

        if (files.length > 1) {
            this.toast.show('Sólo puede adjuntar un fichero', 'error');

            return;
        }
    
        this.files = [...this.files || [], ...Object.values(files)];
        event.target.value = "";
    }

    removeAttachment(file) {
        this.files = this.files.filter((pfile) => pfile!==file);
    }
}
